import moment from 'moment';
import React from 'react';
import { DATE_ONLY_FORMAT, dateString } from 'researcher/helpers/date';
import { translatedLanguages } from 'researcher/digital-translations/translated-languages';
import { T, useTranslate } from 'shared/helper/translate';
var DigitalPurchasesDetails = function DigitalPurchasesDetails(_ref) {
  var digitalPurchases = _ref.digitalPurchases;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return digitalPurchases.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "digital-translation-purchases-header"
  })), digitalPurchases.map(function (digitalPurchase) {
    return /*#__PURE__*/React.createElement("div", {
      className: digitalPurchase.valid ? '' : 'text-danger',
      key: digitalPurchase.identity
    }, /*#__PURE__*/React.createElement(T.md, {
      source: digitalPurchase.valid ? 'digital-translation-uses-will-expire-with-languages' : 'digital-translation-uses-expired',
      params: {
        date: dateString(t, moment(digitalPurchase.endsAt), DATE_ONLY_FORMAT),
        languages: translatedLanguages(digitalPurchase.allowedLanguages, t),
        numberOfUses: digitalPurchase.numberOfUsesRemaining
      }
    }));
  })) : null;
};
export default DigitalPurchasesDetails;